import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/users/$')({
  component: JourneysLegacyRoute,
});
